export const GridPageStripType = {
    GAMES_CATEGORY: 'gamesCategory',
    GAMES_RECOMMENDATIONS: 'gamesRecommendations',
    WINNERS: 'winners',
    PROMOTIONS: 'promotions',
    JACKPOTS: 'jackpots',
};
